import type { DocumentFlagProjection, Flag } from '~/shared/api/data-ingestion-api/client'

import { isFlagNote } from './flag-severity'
import { getPendingFlags } from './get-pending-flags'

export function getFlagSeverityCounts(flags: (Flag | DocumentFlagProjection)[]): {
  note: number
  attention: number
} {
  const pending = getPendingFlags(flags)
  let note = 0
  let attention = 0

  for (const flag of pending) {
    if (isFlagNote(flag)) {
      note++
    } else {
      attention++
    }
  }

  return { note, attention }
}
